import { DefaultChatTransport } from "ai";
import { Chat, type UIMessage } from "@ai-sdk/react";

// Singleton chat instance storage
const chatInstances = new Map<string, Chat<UIMessage>>();

// Helper function to get or create chat instance
export function getChatInstance(
  id: string,
  initialMessages?: UIMessage[],
  onFinish?: (message: any) => void | Promise<void>,
  onError?: (error: Error) => void,
  transportConfig?: any,
): Chat<UIMessage> {
  if (!chatInstances.has(id)) {
    const chat = new Chat({
      id,
      messages: initialMessages || [], // Always use initialMessages from DB for new instances
      transport: new DefaultChatTransport(
        transportConfig || {
          api: "/api/chat",
        },
      ),
      ...(onFinish && { onFinish }),
      ...(onError && { onError }),
    });

    chatInstances.set(id, chat);
  } else {
    const instance = chatInstances.get(id);
    if (instance) {
      // Update onFinish callback for existing instances
      if (onFinish) {
        instance.onFinish = onFinish;
      }

      // Update onError callback for existing instances
      if (onError) {
        instance.onError = onError;
      }

      // For existing instances, only sync if instance is empty (page refresh case)
      if (initialMessages && initialMessages.length > 0 && instance.messages.length === 0) {
        instance.messages = [...initialMessages];
      }
    }
  }

  const instance = chatInstances.get(id);
  if (!instance) {
    throw new Error(`Chat instance with id ${id} not found`);
  }
  return instance;
}
